import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { ArrowRight, Bot, FileText, LayoutTemplate } from "@/components/icons"
import { LaunchTile } from "@/components/layouts/launch-tile"
import { Button } from "@/components/ui/button"

type HeroCardsProps = {
  hasUseCases: boolean
  onAiQuickStart: () => void
  onTemplate: () => void
  onScratch: () => void
}

export function UseCasesHeroCards({
  hasUseCases,
  onAiQuickStart,
  onTemplate,
  onScratch,
}: HeroCardsProps) {
  const { t } = useTranslation()

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col items-center gap-6">
      <div className="flex w-full flex-col items-stretch gap-3 sm:flex-row sm:gap-4">
        {/* AI Quick Start — primary card */}
        <LaunchTile
          className="w-full justify-center sm:flex-1"
          description={t("useCases.landing.aiQuickStartDesc")}
          emphasis="primary"
          icon={Bot}
          title={t("useCases.landing.aiQuickStart")}
          onClick={onAiQuickStart}
        />

        {/* Divider — vertical between cards on desktop; hidden when stacked on mobile */}
        <div className="text-muted-foreground/50 hidden flex-col items-center justify-center gap-1 sm:flex">
          <div className="bg-border h-6 w-px" />
          <span className="text-xs font-medium">{t("useCases.landing.or")}</span>
          <div className="bg-border h-6 w-px" />
        </div>

        {/* Template */}
        <LaunchTile
          className="w-full justify-center sm:w-44"
          description={t("useCases.landing.templateDesc")}
          icon={LayoutTemplate}
          title={t("useCases.landing.template")}
          onClick={onTemplate}
        />

        {/* Blank */}
        <LaunchTile
          className="w-full justify-center sm:w-36"
          description={t("useCases.landing.scratchDesc")}
          icon={FileText}
          title={t("useCases.landing.scratch")}
          onClick={onScratch}
        />
      </div>

      {hasUseCases && (
        <Button asChild className="gap-2 rounded-full px-5" variant="default">
          <Link to="/ai-portfolio/dashboard">
            {t("useCases.landing.viewDashboard")}
            <ArrowRight className="size-4" />
          </Link>
        </Button>
      )}
    </div>
  )
}
